// extracted by mini-css-extract-plugin
export default {"authMainContainer":"Layout_authMainContainer__E-EJO"};